import { Controller } from "@hotwired/stimulus"

// Всплывающее уведомление (тост) справа поверх страницы.
// Появляется с анимацией, автоматически закрывается через timeoutValue (мс)
// и вручную — по кнопке-крестику (data-action="toast#close").
export default class extends Controller {
  static values = { timeout: { type: Number, default: 10000 } }

  connect() {
    // Класс появления вешаем на следующем кадре, чтобы сработал CSS-transition.
    requestAnimationFrame(() => this.element.classList.add("toast-show"))
    if (this.timeoutValue > 0) {
      this.timer = setTimeout(() => this.close(), this.timeoutValue)
    }
  }

  close() {
    clearTimeout(this.timer)
    this.element.classList.remove("toast-show")
    this.element.classList.add("toast-hide")
    const remove = () => this.element.remove()
    this.element.addEventListener("transitionend", remove, { once: true })
    // Фолбэк на случай, если transitionend не сработает.
    setTimeout(remove, 400)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
